document.addEventListener('DOMContentLoaded', function () {
    if ($(window).width() > 1000) {
        var arr = [];
        for (var i = 1; i < 4; i++) {
            arr.push('https://cdn.shopifycdn.net/s/files/1/0011/7220/9721/files/lightho0' + i + '.png?v=1600225341');
        }
        var images = arr;

        // TweenMax can tween any property of any object. We use this object to cycle through the array
        var obj = { curImg: 0 };

        // create tween
        var tween_ct_2 = TweenMax.to(obj, 0.5, {
            curImg: images.length - 1, // animate propery curImg to number of images
            roundProps: 'curImg', // only integers so it can be used as an array index
            repeat: 0, // repeat 3 times
            immediateRender: true, // load first image automatically
            ease: Linear.easeNone, // show every image the same ammount of time
            onUpdate: function () {
                $('.light-box-img').attr('src', images[obj.curImg]); // set the image source
                $('.light-box-textwrapper-button0' + obj.curImg)
                    .addClass('red-btn-sw3')
                    .siblings()
                    .removeClass('red-btn-sw3');
            },
        });

        // init controller
        var controller = new ScrollMagic.Controller();
        if (screen.width > 1800) {
            var scene = new ScrollMagic.Scene({ triggerElement: '.linght-box-container', duration: 1000, offset: 630 })
                .setTween(tween_ct_2)
                .setPin('.linght-box-container')
                .addTo(controller);
        } else {
            var scene = new ScrollMagic.Scene({ triggerElement: '.linght-box-container', duration: 1000, offset: 430 })
                .setTween(tween_ct_2)
                .setPin('.linght-box-container')
                .addTo(controller);
        }
    }
    $('.light-box-buttoncontainer  div[class^=light-box-textwrapper-button]').click(function () {
        $(this).addClass('red-btn-sw3').siblings().removeClass('red-btn-sw3');
        console.log($(this).index());
        switch ($(this).index()) {
            case 0:
                $('.light-box-img').attr(
                    'src',
                    'https://cdn.shopifycdn.net/s/files/1/0011/7220/9721/files/lightho01.png?v=1600225341'
                );
                $('.light-box-imgmo').attr(
                    'src',
                    'https://cdn.shopifycdn.net/s/files/1/0011/7220/9721/files/jingmobile.png?v=1594107037'
                );
                break;
            case 1:
                $('.light-box-img').attr(
                    'src',
                    'https://cdn.shopifycdn.net/s/files/1/0011/7220/9721/files/lightho02.png?v=1600225346'
                );
                $('.light-box-imgmo').attr(
                    'src',
                    'https://cdn.shopifycdn.net/s/files/1/0011/7220/9721/files/yuangguangmobile.png?v=1594107043'
                );
                break;
            case 2:
                $('.light-box-img').attr(
                    'src',
                    'https://cdn.shopifycdn.net/s/files/1/0011/7220/9721/files/lightho03.png?v=1600225352'
                );
                $('.light-box-imgmo').attr(
                    'src',
                    'https://cdn.shopifycdn.net/s/files/1/0011/7220/9721/files/part_1.png?v=1594110258'
                );
                break;
            default:
                break;
        }
    });
});